import styled from 'styled-components';
import {dFlexColumn, dFlexColumnCenter} from '../../../globalVariables/GlobalFlex';
import {ellipsis} from '../../../globalVariables/GlobalVariables';

export const content = styled.div`
    ${dFlexColumn};
    height: 100%;
`;

/* Poster box is locked to the native poster ratio (1080 / 1543, portrait); the image fills it edge-to-edge.
   A correctly-sized poster fills exactly with no crop — the fixed box keeps the layout stable. */
export const poster = styled.div<{$bgColor?: string}>`
    flex: none;
    width: 100%;
    aspect-ratio: 1080 / 1543;
    overflow: clip;
    background: ${p => p.$bgColor ?? 'var(--TA-color-bg-base-alt)'};

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const details = styled.div`
    ${dFlexColumnCenter};
    flex: 1;
    min-height: 110px;
    gap: var(--space-sm);
    padding: 0 10px;
    text-align: center;
    background: var(--primitive-black-05);
`;

export const title = styled.h3`
    font-size: var(--font-size-h3);
    font-weight: var(--font-weight-bold);
    line-height: 1.2;
    word-break: break-word;
`;

export const venue = styled.p`
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-regular);
    line-height: 1.2;
    max-width: 100%;
    ${ellipsis}
`;
